import { CoreAppState } from '../state/core-app.state';
import { BaseResourceService } from './base-resource.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { OrderSource } from '@prisma/client';
import { OrderSourceResourceTypeMappings } from '@aa/nest/resource';
import { orderSourceCompositeKeyOrder } from '@aa/nest/resource/objects';

@Injectable()
export class OrderSourceService extends BaseResourceService<OrderSourceResourceTypeMappings> {
  constructor(
    protected override readonly http: HttpClient,
    protected override readonly store: Store<CoreAppState>,
  ) {
    super(http, store, 'order-sources');
  }
}
